import styled from 'styled-components'


const ButtonFollowStyle = styled.div.attrs( props => ({ className: props.className }))`
    --padding:6px 16px;

    padding:var(--padding);
    color:var(--black);
    border-radius: 30px;
    background-color: var(--lightYellow);
    -webkite-appearance:none;
    transition:var(--trTime);
    cursor:pointer;
    
    &.purple-follow {
        padding: var(--sp2x) var(--sp3x);
        font-size: 14px;
        border-radius: var(--sp1-5x);
        -webkit-appearance: none;
        position: relative;
        background-color: var(--purple);
        color: var(--white);
        transition: var(--trTime) ease-out;
        font-family: PopSemi;
        font-weight: unset;
        border:none;
        white-space: nowrap;
        display: flex;
        align-items: center;

        &:hover {
            background-color: #914EFF;
        }
    }

    .comp-title {
        color:inherit;
    }
    
    .text {
        margin-left:var(--spSize);
    }

    &:hover {
        background-color: #ffecdc;
    }
    
    &.active {
        border:1px solid var(--grey);
        background-color:var(--white);
    }
    
    &.blueBg {
        background-color: var(--white);

        &:hover {
            background-color: #f4faff;
        }
        
        &.active {
            border:none;
            background-color:var(--white);
        }

    }
`
export default ButtonFollowStyle
